module.exports = __webpack_public_path__ + "img/zhzzupanija.ad626320.png";